var _defs, _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _g2, _g3, _path13, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "flag-icon-css-fk",
    viewBox: "0 0 640 480",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a43907"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 444.4,
    x2: 470.9,
    y1: 592.2,
    y2: 577.1,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 458.2,
    x2: 520.5,
    y1: 562.5,
    y2: 552.8,
    gradientTransform: "scale(.94 1.07)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 472.4,
    x2: 445.3,
    y1: 578.7,
    y2: 580.2,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 518,
    x2: 456.4,
    y1: 553.7,
    y2: 558.1,
    gradientTransform: "scale(.94 1.07)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 851.8,
    x2: 646.2,
    y1: 369.9,
    y2: 369.9,
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 388.5,
    x2: 677.4,
    y1: 507.2,
    y2: 508.8,
    gradientTransform: "scale(.82 1.22)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 579.8,
    x2: 556.8,
    y1: 504.9,
    y2: 505.9,
    gradientTransform: "scale(.84 1.2)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 581.4,
    x2: 558.9,
    y1: 512,
    y2: 514.3,
    gradientTransform: "scale(.82 1.22)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 552,
    x2: 589.8,
    y1: 517.9,
    y2: 503.9,
    gradientTransform: "scale(.84 1.2)",
    gradientUnits: "userSpaceOnUse",
    xlinkHref: "#a"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#006",
    fillRule: "evenodd",
    d: "M0 0h400v200H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0v25.6l317.1 203h40v-25.5L39.9 0H0zm357 0v25.6l-317 203H0v-25.5L317.1 0h40z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M148.8 0v228.6h59.5V0h-59.5zM0 76.2v76.2h357V76.2H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M0 91.5v45.7h357V91.5H0zM160.7 0v228.6h35.7V0h-35.7zM0 228.6l119-76.2h26.6l-119 76.2H0zM0 0l119 76.2H92.4L0 17V0zm211.4 76.2L330.4 0h26.7L238 76.2h-26.7zm145.7 152.4l-119-76.2h26.6l92.4 59.2v17z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 10,
    d: "M671 321.6a13.2 13.2 0 0 0-2 .1c-3.4.6-8.8 11.7-11.7 18.2-4.7 5.6-7.1 10-9 13.2-.8 1.3-2 2.7-1.6 4.4-7 1.7-7.4 7.7-7.4 10 0 2.6.8 3.8.8 3.8l4.2 7.8v.1c4.5 9.3 11 21.7 14.8 22.7 5.2 1.5 18.8-3.5 29-12.2a164 164 0 0 0 62 12.6c23.8 0 45.2-5.7 61.9-12.6 10.2 8.7 23.7 13.7 29 12.2 3.7-1 10.3-13.5 14.8-22.7l4.1-7.9s.8-1.2.8-3.7c0-2.3-.4-8.4-7.4-10 .4-1.7-.7-3.2-1.5-4.5-2-3.3-4.4-7.7-9-13.4-3-6.5-8.4-17.4-11.7-18-4.8-.8-15 1.6-15 2.5v.5L795.4 344c0 .5 1 14.5 5 27a147 147 0 0 1-50.5 8.5c-19.8 0-36.7-3.5-50.4-8.6a136 136 0 0 0 5-27L684 324.7v-.5c0-.7-7.9-2.6-13-2.6zm5.2 24c2.6 0 5.3 2.2 7.6 4.5l-.2 1.4a78.7 78.7 0 0 1-3.2 10.6 85.8 85.8 0 0 1-14.3-10.3c2.2-2.4 5.8-5.6 9.6-6.1h.5zm147.6 0h.5c3.8.6 7.4 3.8 9.7 6.2a85.6 85.6 0 0 1-14.4 10.3 78.3 78.3 0 0 1-3.2-10.6 17 17 0 0 1-.2-1.4c2.2-2.4 5-4.5 7.6-4.5zm-166 27.4c2.7 2.1 6.3 4.5 10.6 7a12.3 12.3 0 0 1-3.8 1.7c-1.8.4-3.6.3-5.5-.1a17.5 17.5 0 0 1-1.2-5.7 70.3 70.3 0 0 1-.1-2.9zm184.5 0l-.2 2.9a17.6 17.6 0 0 1-1.2 5.7 12 12 0 0 1-9.3-1.6c4.4-2.5 8-4.9 10.7-7z",
    transform: "matrix(1.17 0 0 1.17 -389.2 -22)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M445.6 595.5s5.7-8.8 10.3-8.1c4.7.6 9.1 6.2 9.4 6.5a41 41 0 0 0 6.9-7.5c-.3-.3-7.2-16.5-11-17.2s-11.8 1.2-11.8 1.8l-3.8 24.5z",
    transform: "matrix(-1.48 0 0 1.54 1073.6 -525.4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M433.1 586.1c0 .6 2 23.8 10 31.9s21.3 13.1 26 11.9c4.6-1.3 15.3-24.7 15.3-24.7s-11.3 11.2-19.7 9.3c-8.4-1.8-13.4-15.9-15-22.8-1.6-6.8-.3-20.3-.3-20.3L433 586.1z",
    transform: "matrix(-1.48 0 0 1.54 1073.6 -525.4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M445.6 595.5s5.7-8.8 10.3-8.1c4.7.6 9.1 6.2 9.4 6.5a41 41 0 0 0 6.9-7.5c-.3-.3-7.2-16.5-11-17.2s-11.8 1.2-11.8 1.8l-3.8 24.5z",
    transform: "matrix(1.48 0 0 1.54 -99.8 -525.4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M433.1 586.1c0 .6 2 23.8 10 31.9s21.3 13.1 26 11.9c4.6-1.3 15.3-24.7 15.3-24.7s-11.3 11.2-19.7 9.3c-8.4-1.8-13.4-15.9-15-22.8-1.6-6.8-.3-20.3-.3-20.3L433 586.1z",
    transform: "matrix(1.48 0 0 1.54 -99.8 -525.4)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.5,
    d: "M656.4 338.6c-4.7 5.7-7.2 10.2-9.2 13.5-2 3.3-.8 8 3.7 14.5 5 7 45.4 34.7 98.1 34.7 52.7 0 93.1-27.6 98-34.7 4.6-6.6 5.8-11.2 3.8-14.5-2-3.3-4.5-7.8-9.2-13.5 0 8.6-33.5 40-92.6 40s-92.6-31.4-92.6-40z",
    transform: "matrix(1.17 0 0 1.17 -388 -20.8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M467.8 625.5l7.2-11.9-3.6-2.5c-1 3-5.1 4-5.8 7.8s2.8 7.5 2.2 6.6z",
    transform: "matrix(1.48 0 0 1.54 -98.8 -524)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M475 623s1.3-5.3-2.8-6c-4-.6-6.2 3-5.6 1.6.6-1.6 3-3.1 3.4-8.4.3-5.3-.3-8.2-.3-8.2s1.6-6.8 8.1-5.9c6.6 1 6.9 6 6.9 7.8s-.6 2.8-.6 2.8L475 623z",
    transform: "matrix(1.48 0 0 1.54 -99.8 -525.4)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M568.3 406.3l2 3.5 1.3-.8-.9-2.3.2-.5 2.3-1.4 6 10.6v.5l-1.3.9.6 1 5.7-3.7-.5-1-1.3.8-.5-.1-6-10.6 2.2-1.5h.5l1.5 2 1.3-.9-2-3.4-11.1 7zm-14.3 8.2l.5 1 1.2-.5.5.1 5.2 10.8-.1.5-1.1.7.4 1 5.7-3-.5-1-1.2.5-.5-.1-2.5-5.1 5.8-3 2.5 5-.1.5-1.2.8.5 1 5.7-3-.5-1-1.2.5-.5-.2-5.2-10.7.1-.5 1.1-.7-.4-1-5.7 3 .5 1 1.2-.6.5.2 2.1 4.4-5.7 3-2.2-4.4.2-.5 1.1-.7-.5-1-5.7 3zm-3.3 9.2l.3 1 1.6-.4.5.2 1.2 4.5-1.1.4c-3.3 1-6-.6-7.2-4.5-1-3.8.3-6.7 3.5-7.7a4.8 4.8 0 0 1 1.9-.2l.4.3 1.1 2.1 1.6-.5-1-3.6c-1.8 0-3.4.2-4.8.6-4.8 1.6-7 5.5-5.8 10 1.3 4.5 5.3 6.6 9.8 5.2a15.4 15.4 0 0 0 4.6-2.4l-1.5-5 .3-.4 1.2-.5-.3-1.1-6.3 2zm-13.3 12.5l6.4-2-.3-1.1-1.5.3-.4-.2-3.5-11.6.2-.4 1.4-.6-.3-1-6.4 2 .3 1 1.5-.3.4.2 3.5 11.6-.3.4-1.4.6.4 1zm-34.8 5.7l11.3-1-.4-4.1-1.4.1-.2 2.4-.2.4-4.9.5-.5-6 2.8-.2.3.3.3 1.6h1.3l-.5-5.3h-1.2v1.7l-.4.4-2.7.2-.5-5.4 4.2-.3.3.2.5 2 1.5-.1-.3-3.6-10.6 1v1h1.4l.3.4 1 12-.2.4-1.3.2v1.2zm-16.9-15v1.1l1.3.1.3.4.2 12-.3.4-1.2.2v1h6V441l-1.3-.1-.4-.4v-5.7l6-.1.1 5.7-.3.4-1.2.1v1.1h6v-1.2h-1.3l-.3-.4-.2-12.1.3-.4 1.2-.1v-1.1h-6v1.2l1.3.1.3.3.1 5-6 .1-.2-5 .4-.3 1.2-.1v-1.1h-6zm-12.8-.4v4h1.4l.4-2.4.3-.3h2.5v12.4l-.4.4h-1.4v1.2h6.3v-1l-1.4-.2-.3-.4.1-12.3h2.5l.3.3.4 2.5h1.4v-4l-12.1-.2zm-19.5 12.9l11 .5.2-4-1.4-.1-.4 2.4-.3.3-4.8-.2.3-6 2.6.2.3.3.2 1.7h1.2l.2-5.2h-1.2l-.3 1.5-.3.3H458l.3-5.5 4 .2.3.3.2 2 1.5.1.1-3.6-10.3-.5v1.1l1.2.2.3.4-.6 12-.3.4h-1.3v1.1zm-25.4-6.6l6 2 .2-1-1.2-.6-.2-.5 3.5-11.5.4-.2 1.3.3.4-1-5.9-2-.3 1 1.2.6.3.4-3.6 11.5-.4.3-1.3-.4-.4 1.1zm-10.4-4a11.4 11.4 0 0 0 3.6 2c3.2 1 5.8-.2 6.5-2.7a4.2 4.2 0 0 0-.7-3.9c-1-1.2-1.9-1.9-2.4-2.5-.8-1-1.1-1.9-.8-2.9.3-1.1 1.5-1.7 3-1.2.5.2 1 .4 1.3.8l.1.4-.3 2.3 1.4.5 1-3.5a11 11 0 0 0-3.4-2c-2.8-1-5.2.3-6 2.7a4.3 4.3 0 0 0 .5 3.4c.6 1.1 1.5 1.8 2.1 2.5 1.2 1.2 1.6 2.3 1.3 3.4-.4 1.2-1.6 1.8-3.2 1.2a5.5 5.5 0 0 1-1.6-.9l-.2-.4.5-2.7-1.5-.5-1.2 4zm-13.3-5.6l10 5 1.7-3.7-1.3-.6-1.3 2-.4.2-4.3-2.2 2.5-5.3 2.4 1.2.1.4-.5 1.6 1.1.6 2.2-4.8-1.1-.5-.9 1.3-.4.2-2.4-1.2 2.2-4.9 3.7 1.9.2.4-.6 1.9 1.3.6 1.5-3.2-9.4-4.7-.5 1 1.1.7.2.5-5 10.9-.4.1-1.2-.4-.5 1zm-1.6-18.2l-5-3.5-.7 1 1 .8.1.5-6.3 10-.5.1-1-.6-.7 1 5 3.4c1.8 1.2 3.3 1.8 4.9 1.6 2.1-.2 4-1.4 5.4-3.7 2.5-4 1.8-7.9-2.2-10.6zm-2.1 0l1 .8c2.7 1.8 3 4.5.7 8s-4.7 4.4-7.4 2.5l-1-.6 6.7-10.6zm40 15.8l-.2 1 1.2.4.2.4-2.4 11.8-.4.3-1.2-.1-.2 1 5.7 1.3.2-1-1.2-.5-.3-.4 1-5 .4.1c2 .5 2.4 1.5 2.5 3.8.1 1.1.1 2.1 1 3.3.4.5 1 1 2 1.1a13.8 13.8 0 0 0 2 .3l.2-1-.2-.1c-1.4-.3-2-.8-2.1-2.1-.2-1.2 0-2.4-.5-3.6a3.5 3.5 0 0 0-1.8-1.8c2.3 0 3.8-1 4.2-3 .5-2.5-.8-4.2-4-4.9l-6-1.3zm4 2.1l.8.2c2 .5 2.8 1.7 2.4 3.5-.4 2.1-1.6 2.8-3.8 2.3-.2 0-.4 0-.7-.2l1.2-5.8zm74 1.3l.2 1.1h1.3l.4.2 1.9 12-.3.3-1.3.4.2 1 6.2-1-.1-1.1-1.4.1-.4-.3-.8-5h.4c2.2-.5 3 .4 4 2.4.5 1 .8 2 2.1 2.7.6.3 1.5.5 2.5.3a16.5 16.5 0 0 0 2.2-.6l-.2-1h-.3c-1.5.3-2.2 0-2.9-1.1-.6-1-1-2.2-1.8-3.1-.6-.6-1.4-1-2.5-1 2.4-.9 3.5-2.4 3.2-4.5-.4-2.5-2.4-3.5-5.8-3l-6.8 1.2zm4.8.5l1-.1c2.1-.4 3.4.4 3.7 2.3.3 2-.6 3.2-3 3.6h-.8l-1-5.8z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M467.8 625.5l7.2-11.9-3.6-2.5c-1 3-5.1 4-5.8 7.8s2.8 7.5 2.2 6.6z",
    transform: "matrix(-1.48 0 0 1.54 1072.7 -524)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeWidth: 1.2,
    d: "M475 623s1.3-5.3-2.8-6c-4-.6-6.2 3-5.6 1.6.6-1.6 3-3.1 3.4-8.4.3-5.3-.3-8.2-.3-8.2s1.6-6.8 8.1-5.9c6.6 1 6.9 6 6.9 7.8s-.6 2.8-.6 2.8L475 623z",
    transform: "matrix(-1.48 0 0 1.54 1073.6 -525.4)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#0072c4",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeWidth: 3.9,
    d: "M396.9 606s-75.5-21.4-75-102.2l.5-107h148.9l.5 106.4c.5 80.8-75 102.7-75 102.7z",
    transform: "matrix(1.48 0 0 1.54 -99.3 -521.5)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "M392.3 129c.2 0 1.5-1.3 2.8-2.4 1.7-1 3.3-2.1 5-3 1.4-.7 4-1.3 5.1-1.9a12.5 12.5 0 0 0 4.2-3.4c.2-2.1.5-3.7.5-6.2 1.8-1 3.4-1.8 5-2.4 2.3-.7 2.8-1.6 5.1-2 1.5-.5 3.9-.5 6-.5 2.3 0 3.7 1.7 5.8 2 2.5 1 3.6 1.7 5.6 3.4 1 1.4 1.7 2.6 3.6 3.6 1.5.8 2.9 2 4.6 2.4 2 1.1 3.6 1.8 5.1 3.4 1.4 1 2 2.4 3.2 3.4a36.1 36.1 0 0 0 4.7 3.4c2 1.3 4 2.3 7.1 2 1.7 0 3.5-.3 5.5 0 2.3 0 4.5 0 6.5.6 2.4 0 4.3.3 6.5.5 2 .3 4.1.4 6.4.4 2 .6 4.2.5 6.5.5h13c2.3 0 4.7.1 6.4.5a51 51 0 0 0 6.5-.5c2.5 0 4.4-.4 6.9-.5h7.8c2 .6 4.6 1 6 2 1.9.5 2.8 1.4 4.6 1.9 1.5.7 3.6 1.9 4.7 3.4a24.7 24.7 0 0 1 3.7 5.3c1.2 1.8 1.7 4 2.7 6.3.6 2.2 1 4.3 1 6.7.5 2.1.4 4.4.4 6.8-.5 2.2-.6 4.6-1.4 6.7 0 2.4-.5 4.5-.9 6.3-.4 2-.9 3.3-1 5.8v6.8c0 2.2-.6 3.8-.8 6.2a71 71 0 0 0-3.3 7.3 14.7 14.7 0 0 0-3.7 3.8c-1 .6-1.5 1.6-1.3 2 1.8.6 1.3 1.9 1.3 4.3.3 1.9.5 4.2 1 6.3.1 2.3.6 3.7 1.3 5.3.8 1 1 .5-.9.5-1.3 1-2.7.5-3.2-1.5a12 12 0 0 1-1.9-5.3c-.2-2.2-.6-4.4-1.3-5.8-.3-2.7-1-2.7-3.7-2.9-1.3-1.1-3-1.4-5.6-1.4-2.5 0-2.7-.3-2.7 2.4v6.8c-.5 2-1.4 3.5-1.9 5.3-1.4 1-2 2.7-3.7 3.8-.8 2.2-1.9 2.6-4.1 3l-2.8-3.4c1.3-2.2 2.4-2.5 3.2-4.9 1-1.9 1.6-3.1 2.3-4.8-1-1.5-1.8-2.2-2.7-4.3a26.3 26.3 0 0 1-2.3-5.3c-1.6-.6-4-.7-5.1-1.5-2.3-.5-2.9 2-5.6 2h-6.4c-2.9 0-3.6 1.5-6 1.4-.7.2-2.5-.1-5.1 0-2 .7-4.3.5-6.5.5-2.3 0-4.2-.6-6-1-2.1-.6-4.2-1.2-6.4-1.4-2.7 0-3.8.2-5.6 1.4-1.4.9-3.5 2.8-5 3.9-.7 1.6-1 4.3-2 6.2-.4 2-1.2 3.1-1.7 4.9a18.4 18.4 0 0 0-1.4 5.8c-.2 3.2-.9 2.8-2.8 1.9-.8-1.4-2-2.8-2.8-4.4.4-2.4 1-3.6 1-6.2-.5-2-1.5-1.8-2.8-.5 0 2.5 0 4.5-1 5.8a6 6 0 0 1-2.7 3.8c-.7 1.8-2.2 2.7-3.7 3.4-.2 0 0-.6 0-2-1.1-2.1 0-4 0-6.7 0-2.4-.2-4 .5-6.2 0-2.4-1-4.6-1.4-6.3-.9-1.8-1.4-2.7-3.7-3.4-1.7-.7-4-1.5-5.1-3a9.6 9.6 0 0 0-4.2-3.3c-2-.7-3.1-1.5-4.6-2.4-1.4-1.6-2.6-2.2-3.2-4.3-1-1.5-1.1-4.3-1.8-6.3a21.7 21.7 0 0 0-1.4-5.8 24.3 24.3 0 0 0-1.4-5.8c-.3-2-.8-4-1.4-6.3 0-2.3 0-4.6-.5-6.7v-6.8c-.3-2-.4-4.8-.9-6.3 0-2.6-.3-4-1-5.8-1-1.7-1-2.4-2.7-2.9-1.2 1.5-3.1 2.2-5.5 2.5-1.7-.4-4.1-.7-6-1.5-1.9-.4-3.1-1.2-4.6-2a43.2 43.2 0 0 0-2.8-3.8c-.3-2.5-.8-3.8-1-6.3 0-1.8.1-.8 2-3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fefefe",
    d: "M419.6 146.4l.4-.4c-.8.8-.5.4 1.3-.3 1-.6 2.9-1.7 3.6-2.4.8-.4 2.2-1 3-1.7.8-1 1.7-1.8 2.9-2.7 1.2-1.1 2.4-1.5 3.9-2.4 1.8-.2 2.5-1 4.2-.4 1.6.4 2.3.4 3.6-1 1.3-.8 2.8-1.7 3.3-3V130c0 2.2-.5 3-2 3.7-1 1.3-2.4 2.6-3 3.8-1 1.5-1.2 2.3-2.2 3-.9 1.1-2.3 1.7-2.6 3.5.4.8 0 1.2 1 1.3.9.8 1.9.5 3.2 0a14.2 14.2 0 0 0 2.6-4c1.1-1.6 1.7-2.3 2.3-3.5 1.2-.8 1.9-1.4 2.3-2.7 1.3-.8 2.4-1.6 3.3-2.4 1-.6 1.5-1.1 2.9-1.4a6 6 0 0 1-1 3.8c-.3 1.9-.2 2.8.4 4 .9.7.7 1.2 1.3 2.5.5-1.2.8-3.4 1-4.8v-.3c0 1.4 0 3.4-.4 4.4 0 2 .5 2.9 1 4.4.5.8 1 1.3 1.6 1.7 0-2 .6-3.2.7-5 .4 1.3.3 3.2.6 4.7.1 1.6.7 2.8 1.3 4.1.8.4 1 1.8 1.3.7.8-2.4.8-5 1.3-7.5.1-1.3.2-3.2.7-4.1l-.7 4c.1-1.2.2-3 .7-4v-.4a39 39 0 0 1 .7 5.5c0 1.5-.1 3 .3 4.4 1-.5 1.7-1.7 2.3-3a18.2 18.2 0 0 1 2.6-3.8l-2.6 3.7a18.2 18.2 0 0 1 2.6-3.7v-.3a40.3 40.3 0 0 0-.3 4.7c0 1.6 0 3.4.3 4.5.4 1.8.9 2.1 1 4 0 1-.2 2 .3 2.5 1.4.3 1.4-.5 1.6-2.4 0-2.2.6-3.7.7-5.8 0-2.6.3.3.6 1.3a13 13 0 0 1 1 4.5c0 1-.1 1.9.3 2.4 1.3-.6 1.8-2 2.6-2.8.7-1.6 1.4-2.3 2-3.4 1.7-.3 1.6-1 1.6-3 0-1.7-.1-3.4.4-4.8a41 41 0 0 0 1.3-4.5c.6-.3 1.2.6 1.6 1.4.7 1.1.6 2.7.6 4.4.4 1.5 1 2.7 1.7 4.1a15 15 0 0 0 2.3 3.4c.3 1.1.3 3 .3 4.5 1.3-1.5 1.5-3.6 1.6-5.8-.2-1.5-.2-3.4-.6-4.8 0-1.5-.4-3-.7-4.1-1-.5-1.3-1-.3-2.4 1-.9 2.2-.5 3.9-.3.9.9 1.2 1.4 1.3 3.4 0 1.8 0 3.2.7 4.4.6 1 1.2 1.7 1.6 3.4.5.5.9 1.2 1.6.4.4-1 .7-3 1-4.1.3-1.3.9-2 1.6-2.4 0 1.9 0 3 .7 4.4.6 1.5 1 2.1 1.6 3.8.7.5.8 1.5 1.7 2 .2-1.6.3-3.4.3-5.4V145c.1-1.6.5-2.5 1-3.8 1 1.4 1 1.9 1 3.8 1-.4 1.2-1.2 1.6-2.4.7-.7 1-1 1.3.7.2 1.8.6 3.4 1 5.1.6.8 1.4 2.7 2.2 3.4a16.4 16.4 0 0 0 2 2.8c.5 1 .6 1.7 2 2 0-2.3 0-4.6-.4-6.8 0-2-.4-2.7-.6-4.5-.6-1.1-.9-2.9-.7-3.4a11 11 0 0 1 3 4.1c.7 1.7 1.4 2.8 2 4.5a20 20 0 0 1 2.5 3.4c1.2 1 1.8 2.1 3 3 .6.6 2 1 2.3.7-.1-2-.4-3.7-1-5.4a9 9 0 0 0-1-4.1c-1.3-1.1-2.3-1.9-3-3.4-.4-.5-.5-.8-.6-1.7a26.3 26.3 0 0 1 4.6 4.7 7 7 0 0 0 2.6 2.4c.6.8 2.5 1.7 3.9 2a5.6 5.6 0 0 0 3.3 2.1l-3.3-2a5.6 5.6 0 0 0 3.3 2v.4a13 13 0 0 0-2-5.5 8.8 8.8 0 0 0-3-3.8 9.3 9.3 0 0 0-3.2-3c-.9-1-2.2-2.8-3-3.4 1.5-1 3.1.6 4.6 1.3 1.3 1.4 2.5 3.2 3.3 4.1a18 18 0 0 0 3 4.5c1.4.8 2.3 1.6 3.5 2.7 2 .5 1.2-.2.7-1.7-.7-2 0-2 1.3-.7.9.7 2 1.7 3.3 2.4.5.7 1.4 1.2 2.2.7.4-.5.4-.5.4-1-.7-2.2-1.3-3.8-3-4.5-.7-1-2-2-3-3-.6-1-1.3-1.6-1.9-2.8l2 2.7c-.7-1-1.4-1.5-2-2.7h-.3c2 0 2.7.6 4.2 1.4a6.8 6.8 0 0 1 3 2.4c.6.8 1.6 1.7 2.3 2.7l3.2 2.4c1.1 1.4 1.3 2.3 1.3 4.4.7 1 .8 3 1 4.1-.2 1.9-.9.4-1-.7-.2-1.5-.8-1.4-2-1 0 2 .3 2.6 1 4.1a8 8 0 0 1-1.2 3.4c-.8.5-1-1-1.7-1.7 0-2-.6-2.3-2-3.4v1.4c.8 1.4 1.6 2.7 1.7 4.7a12 12 0 0 1 .7 4.5c0 1.7 0 3.3-.4 4.8 0 1.8-.3 2.6-.3 4.4v9.6a23.3 23.3 0 0 0-.3 4.4l.3-4.4c-.3 1.2-.3 2.7-.3 4.4v.3c-.6-1.7-1.3-3.2-1.7-5a10.3 10.3 0 0 1-2.2-3.5c-.3-1.5-.4-3.2-.7-4.4-.5-1.2-1-2.5-2-1.7-.4 2.5.1 4 1 6.4.5 1.6.5 3 1 4.5.8 1.8 1.4 2 0 4-.7 1.2-1 1.5-1.3 2.8-1.2.6-1.5 1-1.6 2.4-.4-1.3-1.4-2.9-2-4.4-.6-1.7-1.3-3.4-1.6-4.8-.8-1.2-1.8-3-2.6-3.8-.9-1-2-3-2.6-4-1.3-1.5-1.6-2.4-2.7-3.1-.2-.7-.6-1.6-1.3-1 0 1.6 0 3.3.4 4.7.3 2 .9 3.1 1 5.1v3.8c-.8-2-1.7-3.6-2.3-5.5-.8-1-1.5-3-2.3-3.7-.6-1.4-1-2.5-1.7-3.4-.1-1-.6-1-1-1.7 0 1.9.7 2.6 1 4 .7 1.4.9 3.5.7 4.2-.8-2.4-1.6-5-2.6-7.2-1-1.4-2-3.2-2.6-4.5-1-1.1-2-1.2-3-2a5.9 5.9 0 0 1-2.3-1.7c.3 1.8 1 3 1.3 4.4.3 1.7 1 3.1 1.3 4.5-.3 2.3-.8-.7-1.3-1.7-.3-2-1-3-1.6-4.1-.9-.7-1.7-1.8-2.6-2.4-1-.4-.6 0-.6 1.3 0 2.1 0 3.5.6 4.8.7 1 .7 2.3.7 4.1-.1 1.7-.4 3-.4 4.8v2.7c-.7-1.4-1.4-2.3-2-4.1-1-1.6-1.4-2.7-2.2-4.4-.7-.3-2-.6-2.6 0 .1 1.7.9 2.4 1 4.4-1.3 1.3-1.1 1.7-2-.3-.7-1.6-1.6-1.5-2.6-2.4-1.7-.2-1.1-1.3-1.6-2.8 0-1.3 0-2.6-.4-3.7-1.8 0-2.8 0-3.9 1-.5 1-.3 3 0 4.5v4.7c-.4 1.2-1 1.3-1.3 2.8-.6 1.4-.8 3-1.3 4-1.2 1.1-.7 1.2-1.3-.6v-11c0-1.8.3-2.7.3-4.4-.7-1.4-.8-1.7-3-1.7-.4.9-.2 2.5 0 3.4 0 1.7.2 3.3.4 4.5 0 1.8.2 2.9.3 4.4 0 1.8-.4 3.2-1.3 4-1.1.4-.1 1.2-1.3 1.5a15 15 0 0 1-3.6-2.4c-1.2-.4-2.4-.7-4.2-.7-2.2 0-2.2-.3-3-2a31.4 31.4 0 0 1-1.3-5.5c-.7-1.6-.8-2.7-1.3-4.5a6.2 6.2 0 0 0-2-2.4c-.4 1.8-.8 3.2-.9 5.2-.4.8-.5 2.8-.7 3.7-.6-1-.9-3-1.3-4.4-.6-2-1.1-3.4-3.2-2.7-2.2 0-2.3 0-2.3 2.4l2.6 4v4.8c0 2 .1 2.6-1.3 3-.5-2-1.7-4-3-5.7-.1-1.4-.5-1-1.9-1-.9 0-1.8-.2-2.3.3v3c-.8.2-1 0-1.6-.6-.6 1-.2 2.4 0 3.7-.4 1.6-1 3-1.6 3.8-.2-.5-.5-.3 0-.3-2.3-.9-4-1.4-6-2-1 0-1.9 1.1-2.5 2-1.7.5-2.4 1-4.3 1-1.8 0-2.6.3-4.2.3-1.2.3-2.7.4-4.3.4-.8-.3-2.4-.3-2.9-.7.7-1 1.4-1.5 2-3a20 20 0 0 0 2.6-2.5c.8-.6 1.8-1.9 2.6-2.7.5-1.7 1.2-2 2.3-2.7 2 0 2.3.7 4.2 1 1.9.7 3 1 4-.4 1.5-.6 2.8-1.7 4.5-2l3.3-2c1.4-.9 2-1.8 3.2-2.8.4-1.4 1.4-2.5 1-4-1.8-.5-2.9-.4-4 .6-1.3 1.2-1.6 1.7-3.2 2.7-1.3.4-2 1-3.6 1.4-1.3.5-3 .3-4.5.3s-3.4-.1-4.3.4c1.5-1 3.2-2 4.6-2.4 1.3-.9 1.8-1.3 3.6-1.4.8-1 1.6-1 2-2.7.5-2-1.3-1.4-2.7-.7-1.3.3-2.8 1.2-3.9 1.7a14.3 14.3 0 0 1-4.2.7c-.4-.6.3-1.1.6-2 1.5-.6 1.8-.8 2-2.4-1.8.2-2.4.8-4 1-1.6.4-3.3.6-5.2.7h-4.5c-1.6 0-2.5-.4-4.3-.4-1.3-.7-1.3-1-1.3-3 1-1.2 2-1 4-1l3.5-1.8c1.2-.2 2-.7 1.7-1.3h-4.6c-1.8-.8 0-1.1 1-1.7 1.5 0 3.2 0 4.2.6 2 0 2.7-.7 4.2-2 1.3-1 2-1.7 3.3-2.4 1-1.1 2-1.7 2.6-2.7 1.4-1.3 2.3-2 3-3.1.8-.5 1.4-1 1-1.7-2.1.2-3 1-4.3 2a10 10 0 0 1-2.6 2 8.2 8.2 0 0 1-4.3 1.5c-1.6 0-3-.3-4.5-.4-1.8-.2-.2-.6.3-1.4.7-.4 1.2-1.5.6-2.3-1.3-.5-3-.4-4.5-.4h-4.6c-1.7 0-2.4-.4-3.6-1-.3-1 0-.7 1.3-.7a18 18 0 0 0 4.3-.7c1.5-.4 1.7-1 2-2.7-1.6 0-3.3 0-4.3-.3h-3zm-28.2-7.8c-.3-2.5-.9-3.8-1-6.3 0-1.8.1-.8 1.9-3.3.2 0 1.5-1.3 2.8-2.4 1.7-1 3.3-2.1 5-3 1.3-.7 4-1.3 5.1-1.9a12.5 12.5 0 0 0 4.2-3.4c.1-2.1.4-3.7.4-6.2 1.9-1 3.5-1.8 5.1-2.4 2.3-.7 2.8-1.6 5.1-2 1.5-.5 3.9-.5 6-.5 2.3 0 3.7 1.7 5.8 2 2.5 1 3.6 1.7 5.5 3.4 1.1 1.4 1.8 2.6 3.7 3.6 1.5.8 2.9 2 4.6 2.4 0 1.8.4 1.5-.8 1.5-.2 1.8-.6 1.6-2.3 1.7a8 8 0 0 1-3-2.8c.7-1.7.3 1.5 0 2.1-.8.7-1.3 1.4-2.2.7-.6-1.7-1-2.8-1-4.8-.3-2.1-.9-.6-1.3.3-.5 1.8-.3 2.4.3 3.8-1.7 0-3-.2-4.2-.4-1.2-.3-2.6.1-4 .7-1.7 1.1-1.1 1.1-.3 2.4 1.5.5 2.6 1.3 4 2 1.4-.2 3-.6 4.5-1 1.6-.5 3-.2 4.6 0 .8.5 1.8.5 2.3 1 0 1.1 0 2.2-.4 2.8-.6.5-1.3 1.7-2.3 2a16.1 16.1 0 0 1-4.5 1.8c-2 0-2.8.5-4.3 1.3-.2 1.8-.7 2.2-2.3 2.8a10.3 10.3 0 0 1-4.5 1c-1 0-1.9.1-2.3-.4a12.8 12.8 0 0 0 2.6-4c.3-.8.9-1.2.3-1.8-1.9.1-2.4.1-2.6 2-.2 1.9-.9 2.2-2.3 2.8.4-1.7.5-3 1-4.4a25 25 0 0 1-4.2.3c-1 .6-1.4.9-1 2-1.3.5-3 .2-4.6 0-1.4 0-.6-.6-1.6-1.3-.7-1.3-1.4-1.6-3-1.7-.7 1-2 1.3-2.9 2-1.4.5-2.3.1-3.6-.6-1.6 0-1.4.5-1 1.7.7.4 0 .9 1 1 1 .8 1.8 1 3.6 1 1.4-.4 3-.3 4.6-.3 1.6 0 1.3.4 1.3 2-1 .8-2.6.7-4.3.7a16.6 16.6 0 0 1-3.9-1c-1.5-.1-2.7-.4-3.9 0-.5.6-2 .8-.3 1 .7.7 4.5.3 4.7 1.5 1 1 .7 2.3-.8 2.3a2.2 2.2 0 0 0-2.3 0c-1 .2-2.4 0-4.3.2 2.5.2-1.8-2.7-2.7-3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "M401.7 127.3l-2 1.3c-1.4.8-3 2-3.9 2.7-.7.6-.7 1-1.6 1 1.5-.2 2.2-.6 3.6-1.3 1.7-.2 3.3-.6 4.2-1.4.9-.3 0-1.6-.3-2.4zm15-16.1c.2 0 .6 1 1.3 1.7.5 1.3 1 2.2 1 3.8.4-1.7 1-3 1.3-4.8-.5-1-.5-1.3-2-1.4 0 1 .2.3-1.6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c2",
    stroke: "#000",
    strokeWidth: 0.9,
    d: "M349.4 417.7c-.5 0 .8-.5 1.3-.6.4-.8.6-1.3 1.3-1.8 1.1 0 1.7.4 2.2 1.1 1 .3 1.3.7 2.4.9.5.4 1 .4 0 .7-.6.3-1.5.4-2.6.4a7.2 7.2 0 0 0-2.6.7c-1.5 0-1.3 0-2-1.4z",
    transform: "matrix(1.48 0 0 1.54 -109.5 -520)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bcbcbc",
    d: "M422.6 111.5v.4c0-1 0-.5.3 1.4a9 9 0 0 1 .7 4 6.7 6.7 0 0 0 2-3c0-2.7-.5-2.6-3-2.8zm12 39.3h.4c-1 0-.4 0 1.3-1 1.1-.8 2-2 3.6-2.4a13 13 0 0 1 4.2-2.4c.8-.4 1.5-1 2.3-.3-.2 1.6-.5 2.3-2 3-.7 1-1.8 1.6-2.9 2-1 .6-2.2.6-2.6 1.8-1.8.8-2 .6-4.2-.7zm6.3 9.9c.5-.5 2.6-2.6 3.6-3.4a15 15 0 0 1 3.2-3.4c1-1.5 2.2-2.5 3-3.8l2.6-3.4c0 1.5-.2 3.5.3 4.4a7 7 0 0 1-1 4.1c-.7 1.2-1.3 2-3 2.8-1.4.8-2.3 1-3.5 2a26 26 0 0 1-3 1.7c-.9.4-.5.3-2.2-1zm-10.2 7.8h.4c-1 0-.5.1 1.3-1 1.4-1.4 2.5-2 4.2-2.7a10.3 10.3 0 0 0 4-1c.7-.2 1.3-.7 1.9 0 1 1.4 1.3 1.8-.3 2.7a9.4 9.4 0 0 1-3.3 1.7c-.8.7-2.4.7-4 1-1.2 0-2 .2-2.5-.7l2.6.7c-1.3 0-2 .2-4.3-.7zm14 0v-.3c0 1 0 .5.7-1.4 1.3-1.9 1.7-3 3.3-3.4.7-1 2-1.2 3.6-1.7.6 1 .1 2.2 0 3.4-.4 1.3-1.6 2.2-2.3 3.1-1 .7-1.4 1.4-3 1.7-1.2 0-.5 0-2.2-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.8 124.2c0 .9-.7 1.7-1.6 1.7-1 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7c.9 0 1.6.7 1.6 1.7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#005120",
    fillRule: "evenodd",
    stroke: "#002b0d",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.8 479.6h.9c-2.8 0-1.1-.2 3.5 3.5 2-1.6 2-1.8 3.5 1 1 1.5 1.2-.2 2.7-1.8.7 3.2 1.1 6.5 3.5 3.5 2.8 0 5.6-.2 7.1.9 1.8 3.3 1.2-.6 2.6.9 4 .4 3.9-3.4 8.1-4.4 2.6 3.3 3.8.8 7-.8 2.5.6 4.8 4.3 5.3.7 2-3.2 2.1-3 3.5 0 2 1.8 2.8-.8 4.4-1.7 3 1.7 6.3 2 10.6.9.8 2.9 2.6 1.6 4.5.8 3.9 1.7 5.2 2.2 9.7 0 2.2-2.6 1 .1 2.6 1.8 3.3-1 2.4-1.2 6.2-.9 3.9 0 4.2 0 5.3-2.6 2 1.9 2.6 3.3 5.3.9 4.2 0 2.9.5 5.3-1 1.9 4 2.3 1.2 4.5 2.7a14.5 14.5 0 0 1-6.2 7c-1.7 3-2.8 6-6.2 7.2-2.5 2.5-5.2 4-8 6.2-3.8 1-8 .8-12.3.8H388c-2.6 1.4-7 2-10.6 2.7-4 0-8.7 0-11.5-.9-1.9-1.9-5.2-4-7-6.2-2-1.5-2-4.4-3.6-6.2-1.4-2.5-2-6.5-3.5-8.8v-6.2z",
    transform: "matrix(1.48 0 0 1.54 -103 -521.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.5 487.6v.8c0-2.4.1-1.1-1.8 3.6-.3 1.1-1.2 1.4-2.6 1.8m-3.5-2.7h.9c-3.3 3-5.5 4.5-6.2 8l6.2-8c-3.3 3-5.5 4.5-6.2 8m-7.1-12.4s-.1 3.1-.9 4.4m-2.6 1.8v.8-.8zm-7.1-5.3h.9-1c.4 0 .7 0 0 0zm-49.5 0c.4 0 2.2 2.8 4.4 4.4-.5 2.6-1.4 5.6 0 8m2.7-7.1c.4 0 2.1 2.8 4.4 4.4l-4.4-4.4c.4 0 2.1 2.8 4.4 4.4v.9c0-2.8-.2-5.6.9-7.1 1 1.7 2.2 4.3 2.6 1.8 5-.2 7.4-1.6 10.6-2.7 0 1.3-.2.7 1 1.8m60-3.6h.9c-1.7 1.4-3 4.3-4.4 6.2m-32.7-8.8h7",
    transform: "matrix(1.48 0 0 1.54 -103 -521.4)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M413.6 239.3c-15.7 0-20.9 16.4-36.6 16.4h-.9v1c0 11.4.8 22 2.5 31.9 14.5-1 19.8-16.4 35-16.4 15.7 0 21 16.4 36.7 16.4s20.9-16.4 36.6-16.4 21 16.4 36.7 16.4 20.9-16.4 36.6-16.4c15.1 0 20.5 15.2 35 16.3a189.8 189.8 0 0 0 2.5-32.7h-.9c-15.7 0-20.9-16.4-36.6-16.4s-21 16.4-36.6 16.4-21-16.4-36.7-16.4-21 16.4-36.6 16.4-21-16.4-36.7-16.4zm0 64.1c-12.2 0-18 10-27.5 14.3a151.4 151.4 0 0 0 11.7 24.9c4.5-3.4 9.2-6.3 15.8-6.3 15.7 0 21 16.4 36.6 16.4 15.8 0 21-16.4 36.7-16.4s21 16.4 36.6 16.4 21-16.4 36.7-16.4a25 25 0 0 1 15.5 6 152.8 152.8 0 0 0 11.7-24.7c-9.2-4.5-15.1-14.2-27.2-14.2-15.7 0-21 16.4-36.7 16.4s-20.9-16.4-36.6-16.4-21 16.4-36.6 16.4-21-16.4-36.7-16.4zm73.3 64c-15.7 0-21 16.5-36.6 16.5-14.9 0-20.4-14.7-34.2-16.3 18.5 20.6 39.4 33 53.7 40 4.9-3.8 9.9 4.5 17 4.5 7.3 0 12.2-8.4 17-4.7a176.2 176.2 0 0 0 53.3-39.7c-13.4 2-19 16.2-33.6 16.2-15.7 0-20.9-16.4-36.6-16.4z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.18 0 0 1.18 -407 -18.2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M332.5 541.4a110 110 0 0 1 10.5-3l16.3 15.7-13.4 2.7-13.4-15.4z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.6,
    d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 31.3l6.7-31.1m-4.4 31.2l5.6-31.2m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5",
    transform: "matrix(1.06 0 0 1.03 276.8 -178)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.4,
    d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1l6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5",
    transform: "matrix(-1.25 0 0 1.76 1290.4 -502)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1l6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5",
    transform: "matrix(-1.25 0 0 1.3 1321.3 -302)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M395.3 572.2l.9-73s2.6-.3 2.6 0-.3 72.7-.6 73-3.2.5-2.9 0zm28.5-69.8l-.6 61.3-2 2.4.6-63.7h2z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M363 560.2s3 30 36.4 29.1 42.7-30.2 42.7-30.2l-14.5-.6c-.3 0-11.6 14-26.2 13.7s-19.2-3.8-22.4-6.7c-3.2-3-6-7.3-6-7.3l-17-6.7 1 6.4 6 2.3zm90.3-3l-1-4v-3.4l1.6-3.6s-25.3 3.7-25.3 4l-.1 6.8 24.8.1z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M448.5 549.8l-.6 6h4.1l-.3-6h-3.2zm-4.3.3l-.3 6.4 2.6-.3.3-6.1h-2.6zm-4.4 6.4v-5l2.6-.9.3 5-2.9.9zm-5-.3l.6-4.4 3 .3.2 4.7-3.8-.6zm-5.5 0l.3-3.8 3-.3v4.4l-3.3-.3zm-67.4 3.7c.9 0 7.6 1.5 7.6 1.5l7 9.3",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M366.8 561.1c.3.3 6.1 19.8 34 19.8s34.6-22.1 34.6-22.1",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M439.8 559.4s-13.4 29-39 27c-25.5-2-29.6-11.6-31.6-16.6-2-5-3.2-9-3.2-9",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M373.2 558.2c.3-1.7.3-54.4.3-54.4l-1.7-.2-.3 53.7 1.7 1zm-41.5-17.1l22 10.7-.5 1.5S332 543.3 332 543c0-.3.2-1.5-.3-2z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M341.8 537.9c0 .8 3.2 18.6 3.2 18.6s2 .3 2 0l-3.4-18.3-1.8-.3zm20.4.5c1.1 0 21-3.2 21-3.2l-.4 3.2-19.5 2-1.1-2z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M365 514.3c.7 0 7 3.2 9.7 2.4s.9-3 1.4-3c.6 0 2.6 1.5 3.8.3 1.2-1.1 2-4.6 1.5-4.3-.6.3-16 5.8-16.3 4.6z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M362.5 521.6c1.1.3 23.8-6.1 23.8-6.1s0 2-.3 2l-23.5 6.1v-2z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M415 512.6s1.5 3.5 3 2.9 2.9-1.8 2.9-1.8 1.2 3 3.2 2.4c2-.6 3.2-3.8 3.2-3.8s2 .6 2.9.3c.9-.3 2-5 2-5l-17.1 5zm-1.7 28.2c-.3.6 1.5 2 3 2s2-2 2.3-1.4c.3.5.3 3.2 4 2.3s3.8-3.5 3.8-3.5-1.1.9 1.5 1.2c2.6.3 5.2-3.8 5-3.8-.4 0-19 3.5-19.6 3.2z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M363.4 513.1a5 5 0 0 0 .2 2.7l19-6.4s.8-1.5 0-1.5-19.5 5.8-19.3 5.3zm25-4c.5 0 19.4-6.1 19.4-6.1s.3 2.6 0 2.6l-17.7 5.2-1.8-1.7z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M413.3 521.9s-2.9 3.2-2 7.5c.9 4.4 2 8.2 2.3 8.2s3.5-5.8 7-6.1 9.9 3.2 9.9 3.2-.9-7-.6-10.2c.3-3.2 5.2-8.7 5.2-8.7l-21.8 6z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M386.9 516.6s-.6 2.7-.3 2.7l24.7-6.4V511l-24.4 5.5z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b6b6b4",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M355.5 551.8s-5.8-.8-5.5.6c.3 1.5 2.9 2.9 3.2 3.8.3.9-.9 4 .9 3.8 1.7-.3 3.4-1.5 3.4-2.4l-.3-5-1.7-.8z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M387.8 537.3v2l20.9-2.9-.6-1.5-20.3 2.4z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M363 540.8c.4 0 0 2.6 2.4 2 2.3-.6 2.9-2 2.9-2s.6 3.2 3.8 2.9c3.2-.3 5-3.8 5-3.8s.2 2.6 2.2 1.7 2.6-2.9 2.6-2.9l-18.3 2.6-.5-.5zm0-17.2s-2.6.9-1.7 6.1 3 8.2 3.2 8.2c.3 0 2.6-5 6.1-5.8 3.5-1 9.6 2.6 9.6 2.6s-.6-4.7.3-9c.9-4.4 3.8-7.6 3.8-7.6s-20.4 5.5-21.2 5.5z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M411.9 538.7l.3 1.8s21-2.6 21-3c0-.2 0-2-.4-2-.3 0-20.6 3.5-21 3.2zm-.3-18.6l.3 2 24.7-6.6s.6-1.8.3-1.8-24.7 7.3-25.3 6.4z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M414.2 510.8s-.3 1.8 0 1.8 18.3-4.4 18.3-4.7c0-.3 1.8-2 .3-1.7-1.4.3-18 5.5-18.6 4.6zm38.7 33.7l-18-28.4m-2.4 19.7c.3-.8 1.2-18.3 1.2-18.3",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fecf3e",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M389 510c1 .2 3.1 3.2 4.3 2.6 1.2-.6 2.9-2.4 2.9-2.4s-.3 3.5 2 3c2.4-.6 2.7-3 2.7-3s1.7 1 3.2 0c1.4-.8 2.8-5.2 2.3-5.2s-16.9 5.2-17.5 5zm-.6 8.4c0 .6-3 5.2-2 9.6s2.5 8.4 2.8 8.4 4.7-4.6 8.5-5.5c3.7-.9 9.3 2.9 9 2.9-.3 0-1.5-4.4-1.5-7.6 0-3.2 4.4-13 4.4-13l-21.2 5.2zm0 21c0 .2.8 2.2 2.9 2.2 2 0 2.3-2 2.3-2s-.3 3.5 2.9 3.2c3.2-.3 4.3-3.5 4.3-3.5s.3 1.8 3 .9c2.6-.9 6-3.8 5.8-3.8-.3 0-21 3.8-21.3 3z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("use", {
    width: 992.1,
    height: 496.1,
    transform: "translate(-6.6 7.3)",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    width: 992.1,
    height: 496.1,
    transform: "translate(6.6 3.8)",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("use", {
    width: 992.1,
    height: 496.1,
    transform: "translate(0 11)",
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    fill: "#be0f17",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.6,
    d: "M409 477a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0z",
    transform: "matrix(.04 -1.07 1.02 .04 251.6 668)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M398.2 500c0-.2 9 3.8 9 4.1 0 .3 32 42.8 32.3 42.8m-16-42.8l8.2 3.5 2.6 6.4m-61.4-10.4c-.3 0 9 7 9 7l1.2 5.7M341.3 546c4-1.7 32.2-26.4 32.2-26.4m-39.8 21.7l31.7-26.7m21.2 4l30 49.8m-3.6-29.2s3.5 11.7 7 13.5 7.6 4.6 7.6 4.6",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M412.6 539.5s2.5 13.8 6 16.4 7 5.5 7 5.5",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M391 439s3.4 19.2 10.4 23.6a950 950 0 0 1 12.8 8.1",
    transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M390.7 438.7s7.5 15.2 14 19.8c6.3 4.7 15 9 15 9M366.3 440c2 3.5 1.7 10.2 4 12.5a66 66 0 0 1 5.8 7.6m-9.3-19.9c1.2 1.7 4.4 10.4 6.4 13 1.5 2.4 16.3 17.2 16.3 17.2",
    transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M384.6 471.1a2.2 2.2 0 1 1-4.4 0 2.2 2.2 0 0 1 4.4 0zm10.7 4.7a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0zM409 477a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0zm11.9-4.5c0 1-.7 1.7-1.6 1.7-.9 0-1.6-.8-1.6-1.7s.7-1.8 1.6-1.8c.9 0 1.6.8 1.6 1.8zm9.6-5.7c0 .9-.9 1.6-1.9 1.6s-1.9-.7-1.9-1.6c0-.9.9-1.6 1.9-1.6s1.9.7 1.9 1.6z",
    transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "red",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M374.1 404.4c-.9.6-15.4 4.1-13.4 3.8 2-.3 13.7 3 13.4 2s0-5.2 0-5.8zm24.7-4.3c-.6 0-9 3.2-8.7 3.2s9.6 2.6 9.3 2c-.3-.6-.3-4.4-.6-5.2zm25.3 2.9c-.6.3-10.5 2.6-8.7 2.9s8.4 2.6 8.4 2c0-.5 0-4.6.3-5z",
    transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1l6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5",
    transform: "matrix(1.25 0 0 1.3 256.3 -299.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 31.3l6.7-31.1m-4.4 31.2l5.6-31.2m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5",
    transform: "matrix(1.25 0 0 1.36 225.3 -323.4)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M413.6 471c.3-4.6 8.8-31 8.8-31m-5.9 30.1l6.7-30m-3.7 27.7c.2-1.7 4.9-27.6 4.9-27.6m-10.5 27c1.5-.8 5.8-2 5.8-2m-3.7-2.6c1.4 0 4.3-1.2 4.3-1.2m-3.5-2.3a24 24 0 0 1 4.4-1.2m-3.8-3.2l4.7-.8m-2.6-3c0 .3 3.2.3 3.2.3m-2.4-3.7l3.2.5",
    transform: "matrix(-1.25 0 0 1.32 1259.2 -307.3)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dd8b59",
    fillRule: "evenodd",
    stroke: "#512007",
    strokeWidth: 0.5,
    d: "M426.4 558.5l27.6.6.3-2-28.5-.3.6 1.7zm1.2-7.3c3.2 0 27.3-4.6 27.3-4.6s.9-3 0-3-27.3 5.6-27.3 5.6v2z",
    transform: "matrix(1.25 0 0 1.3 259.4 -430)"
  }), /*#__PURE__*/React.createElement("use", {
    width: 992.1,
    height: 496.1,
    transform: "translate(0 5.5)",
    xlinkHref: "#k"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFk);
export default __webpack_public_path__ + "static/media/fk.bbf6a79c8784c908ebf63794bea48e58.svg";
export { ForwardRef as ReactComponent };